import { useState, useEffect, useRef } from 'react'
import { format } from 'date-fns'
import { parseDateSafely } from '../../../utils/date'

export const useDateAndTime = (claimData: any) => {
  const [openStartDate, setOpenStartDate] = useState(false)
  const [openFinishDate, setOpenFinishDate] = useState(false)
  const [openStartTime, setOpenStartTime] = useState(false)
  const [openFinishTime, setOpenFinishTime] = useState(false)

  const [startDateString, setStartDateString] = useState('')
  const [finishDateString, setFinishDateString] = useState('')

  const [timeStart, setTimeStart] = useState<Date | null>(null)
  const [timeFinish, setTimeFinish] = useState<Date | null>(null)

  const [selectedStartDate, setSelectedStartDate] = useState<Date>(new Date())
  const [selectedFinishDate, setSelectedFinishDate] = useState<Date>(new Date())

  const dropdownStartDataRef = useRef<HTMLDivElement>(null)
  const dropdownFinishDataRef = useRef<HTMLDivElement>(null)
  const dropdownStartTimeRef = useRef<HTMLDivElement>(null)
  const dropdownFinishTimeRef = useRef<HTMLDivElement>(null)

  const startDate = claimData.startDate.slice(0, 10).split('-').reverse().join('.')
  const startTime = claimData.startDate.slice(11, 16)
  const endDate = claimData.endDate.slice(0, 10).split('-').reverse().join('.')
  const endTime = claimData.endDate.slice(11, 16)

  const getFormatDate = (time: Date | null) => {
    if (time !== null) {
      const hours: string = time.getHours().toString().padStart(2, '0')
      const minutes: string = time.getMinutes().toString().padStart(2, '0')
      const seconds: string = time.getSeconds().toString().padStart(2, '0')
      return `${hours}:${minutes}:${seconds}`
    } else {
      return null
    }
  }

  const onChangeStartDate = (date: Date) => {
    setSelectedStartDate(date)
    setStartDateString(format(date, 'dd.MM.yyyy'))
    setOpenStartDate(false)
  }

  const onChangeFinishDate = (date: Date) => {
    setSelectedFinishDate(date)
    setFinishDateString(format(date, 'dd.MM.yyyy'))
    setOpenFinishDate(false)
  }

  const handleTimeStartChange = (time: Date | null) => {
    setTimeStart(time)
  }

  const handleTimeFinishChange = (time: Date | null) => {
    setTimeFinish(time)
  }

  const openStartDateDropDown = (e: React.MouseEvent) => {
    e.stopPropagation()
    setOpenStartDate(!openStartDate)
  }

  const openFinishDateDropDown = (e: React.MouseEvent) => {
    e.stopPropagation()
    setOpenFinishDate(!openFinishDate)
  }

  const openStartTimeDropDown = (e: React.MouseEvent) => {
    e.stopPropagation()
    setOpenStartTime(!openStartTime)
  }

  const openFinishTimeDropDown = (e: React.MouseEvent) => {
    e.stopPropagation()
    setOpenFinishTime(!openFinishTime)
  }

  useEffect(() => {
    if (claimData?.startDate) {
      const startDateObj = parseDateSafely(claimData.startDate)
      setSelectedStartDate(startDateObj)
      setStartDateString(format(startDateObj, 'dd.MM.yyyy'))
      if (startTime) {
        const [hours, minutes] = startTime.split(':')
        const timeObj = new Date()
        timeObj.setHours(parseInt(hours), parseInt(minutes), 0, 0)
        setTimeStart(timeObj)
      }
    }
  }, [claimData?.startDate])

  useEffect(() => {
    if (claimData?.endDate) {
      const endDateObj = parseDateSafely(claimData.endDate)
      setSelectedFinishDate(endDateObj)
      setFinishDateString(format(endDateObj, 'dd.MM.yyyy'))
      if (endTime) {
        const [hours, minutes] = endTime.split(':')
        const timeObj = new Date()
        timeObj.setHours(parseInt(hours), parseInt(minutes), 0, 0)
        setTimeFinish(timeObj)
      }
    }
  }, [claimData?.endDate])

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        dropdownStartDataRef.current &&
        !dropdownStartDataRef.current.contains(event.target as Node)
      ) {
        setOpenStartDate(false)
      }
      if (
        dropdownFinishDataRef.current &&
        !dropdownFinishDataRef.current.contains(event.target as Node)
      ) {
        setOpenFinishDate(false)
      }
      if (
        dropdownStartTimeRef.current &&
        !dropdownStartTimeRef.current.contains(event.target as Node)
      ) {
        setOpenStartTime(false)
      }
      if (
        dropdownFinishTimeRef.current &&
        !dropdownFinishTimeRef.current.contains(event.target as Node)
      ) {
        setOpenFinishTime(false)
      }
    }

    window.addEventListener('click', handleClickOutside)

    return () => {
      window.removeEventListener('click', handleClickOutside)
    }
  }, [])

  return {
    openStartDate,
    openFinishDate,
    openStartTime,
    openFinishTime,
    startDateString,
    finishDateString,
    timeStart,
    timeFinish,
    selectedStartDate,
    selectedFinishDate,
    dropdownStartDataRef,
    dropdownFinishDataRef,
    dropdownStartTimeRef,
    dropdownFinishTimeRef,
    onChangeStartDate,
    onChangeFinishDate,
    handleTimeStartChange,
    handleTimeFinishChange,
    openStartDateDropDown,
    openFinishDateDropDown,
    openStartTimeDropDown,
    openFinishTimeDropDown,
    getFormatDate,
  }
}
